import { render, staticRenderFns } from "./BottomMenuBlock.vue?vue&type=template&id=0862ee2e&scoped=true&"
import script from "./BottomMenuBlock.vue?vue&type=script&lang=js&"
export * from "./BottomMenuBlock.vue?vue&type=script&lang=js&"
import style0 from "./BottomMenuBlock.vue?vue&type=style&index=0&id=0862ee2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0862ee2e",
  null
  
)

export default component.exports